



































import {Component, Prop, Vue} from 'vue-property-decorator';
import {SelectableStore} from '@/components/mass-import/SelectableStore';
import {Inject} from 'vue-typedi';
import {ProductService} from '@/services/ProductService';
import {CsvValidation} from '@/helpers/csv/CsvValidation';
import AlertMessage from '@/components/mass-import/steps/AlertMessage.vue';
import StoreSelectionSummary from '@/components/mass-import/steps/StoreSelectionSummary.vue';
import CsvFileTable from '@/components/mass-import/steps/CsvFileTable.vue';

@Component({
  components: {CsvFileTable, StoreSelectionSummary, AlertMessage}
})
export default class UploadProductsStep extends Vue {

  private static readonly MASS_IMPORT_FAILURE_ERROR_MESSAGE: string = 'Une erreur s\'est produite pendant la mise à jour en masse';

  @Prop({default: {value: false}}) public readonly allStoresSelectedContainer: {value: boolean};
  @Prop({default: []}) public readonly selectableStores: SelectableStore[];
  @Prop({default: {value: null}}) public readonly uploadedFileContainer: {value?: File};
  @Prop({default: {value: new CsvValidation()}}) readonly uploadedFileCsvValidationContainer: {value: CsvValidation};
  @Prop({default: () => {}}) public readonly previousStepHandler: () => void;
  @Prop({default: () => {}}) public readonly nextStepHandler: () => void;

  @Inject()
  productService!: ProductService;

  public massImportInProgress: boolean = false;
  public massImportSuccess: boolean = false;
  public readonly errorMessages: String[] = [];

  public sendMassImportData() {
    this.massImportInProgress = true;
    this.productService.sendMassImport(this.uploadedFileContainer.value, this.selectableStores.filter(selectableStore => this.allStoresSelectedContainer.value || selectableStore.checked).map(selectableStore => selectableStore.store.storeId))
        .then(() => {
          this.massImportSuccess = true;
          this.nextStepHandler();
        })
        .catch(error => {
          this.massImportSuccess = false;
          this.errorMessages.length = 0;
          if (error.response && error.response.status === 400 && error.response.data && error.response.data.messages) {
            this.errorMessages.push(...error.response.data.messages);
          } else {
            this.errorMessages.push(UploadProductsStep.MASS_IMPORT_FAILURE_ERROR_MESSAGE);
          }
        })
        .finally(() => {
          this.massImportInProgress = false;
        });
  }

}
